import React from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { log } from "@assets/js/utils";

import "./category-navigation-list.scss";

const CategoryNavigationList = ({ fields, itemId }) => {
    if (fields?.data?.item?.Links?.values?.length > 0) {
        return <div className="category-navigation-list">
            {fields.data.item.Links.values.map((item, index) => {
                const classList = classnames({
                    "category-navigation-list__item": true,
                    "is-active": itemId === item.id
                });
                return <NavLink className={classList} to={item.url} key={index}>{item.displayName}</NavLink>
            })}
        </div>
    }
    else
    {
        return <></>;
    }
}

export default CategoryNavigationList;